<template>
    <div>
        <section class="ai-page-2-head">
            <button type="button" class="ai-btn-prev" @click="changeStep(1)">
                <img :src="`${m_cloud_url()}uteach/assets/ai-left-chevron 1.svg`" alt="Go to first step" width="22" height="22">
                <span>Go to first step</span>
            </button>

            <div class="ai-page-2-container">

                <div v-if="namesResponseData">
                    <div v-for="(name, index) in namesResponseData" :key="index" class="ai-page-2-item">
                        <p>{{name}}</p>

                        <button type="button" class="ai-gen-btn" @click="generateDescription({name, index})">
                            <img :src="`${m_cloud_url()}uteach/assets/ai-generate-distribution.svg`" alt="Generate" width="15" height="16">
                            <span>Generate description</span>
                        </button>

                        <button type="button" aria-label="Copy" class="ai-btn-copy" title="Copy" @click="copyToClipboard(name, index)">
                            <img v-if="copiedNameIndex !== index" :src="`${m_cloud_url()}uteach/assets/ai-copy.svg`" alt="Copy" width="14" height="16">
                            <img v-else :src="`${m_cloud_url()}uteach/assets/ai-checkmark.svg`" alt="Copy" width="12" height="12">
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    components: {},

    data() {
        return {
            copiedNameIndex: null,
        };
    },

    computed: {
        ...mapGetters(['namesResponseData', 'currentTitle'])
    },
    methods: {
        ...mapActions(['changeStep', 'saveDescriptionsResponseData', 'setCurrentTitle', 'generateDescription']),

        async copyToClipboard(text, index) {
            try {
                await navigator.clipboard.writeText(text);
                this.copiedNameIndex = index;
            } catch (err) {

            }
        }

    },
};
</script>


<style scoped>

</style>
